import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllEvent } from '../../store/event'
import { eventExportColumns } from '../../config/exportColumns/eventExportColumns'

function Event() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Events</div>

					<div className="d-flex gap-2">
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllEvent({
										...params,
										...exportFilters,
										hub: hubId || permissionOfHub,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={eventExportColumns}
							fileName="Events"
							sheetName="Event List"
							buttonText="Export Events"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/event/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Event
						</button>
					</div>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Event
